module.exports = __webpack_public_path__ + "static/media/6.6bf0007f.png";